export type ClientPlatform = "windows" | "macos" | "linux" | "unknown";

function normalizePlatform(value: string): ClientPlatform {
  const normalized = value.toLowerCase();

  if (normalized.includes("win")) {
    return "windows";
  }

  if (normalized.includes("mac") || normalized.includes("darwin") || normalized.includes("ios")) {
    return "macos";
  }

  if (normalized.includes("linux") || normalized.includes("x11")) {
    return "linux";
  }

  return "unknown";
}

export function detectOperatingSystem(): ClientPlatform {
  if (typeof navigator === "undefined") {
    return "unknown";
  }

  const structuredPlatform = navigator.userAgentData?.platform;
  if (structuredPlatform) {
    return normalizePlatform(structuredPlatform);
  }

  const userAgent = navigator.userAgent;
  return normalizePlatform(userAgent);
}

export function getPlatformLabel(platform: ClientPlatform) {
  switch (platform) {
    case "windows":
      return "Windows";
    case "macos":
      return "macOS";
    case "linux":
      return "Linux";
    default:
      return "Unknown";
  }
}
